import Geofence from '@/pages/GeofenceManagement/Geofence';
import type { RouteConfig } from '@/types/routestypes';

 const GeofenceManagementRoute : RouteConfig = {
   path: "geofence-management",
    element: <Geofence />,
    pageName: "Geofence Configuration",
    sidebar: { show: true, icon: "" },
    permission: ["ManageGeoFence"],        
}


export default GeofenceManagementRoute;
